// sendCommandFlex35.js
import { nodeRedApi } from '../../services/axios';

export async function sendCommandFlex35(descricao, action) {
  console.log(`Comando enviado da lâmpada de ID ${descricao} com a ação`, action);

  const payload = {
    buttonId: descricao,
    action: action,
  };

  try {
    const response = await nodeRedApi.post('/ComandoFlex35', payload);

    console.log('Comando Flex35 enviado. Status:', response.status);
    return response.data;
  } catch (error) {
    console.error('Erro ao enviar comando Flex35:', error);
    throw error;
  }
}